import { render, staticRenderFns } from "./CanaliSocial.vue?vue&type=template&id=f893d1aa&"
import script from "./CanaliSocial.vue?vue&type=script&lang=js&"
export * from "./CanaliSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports